<p-skeleton  [style]="{ aspectRatio: aspectRatio }"></p-skeleton>
